import { styled, typography } from '@pulse-web-ui/theme';

export const RewardHint = styled.p`
  ${typography.regular14}
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-bottom: 16px;
`;
